import React from "react";
import PropTypes from "prop-types";
import TabContent from "reactstrap/lib/TabContent";
import TabPane from "reactstrap/lib/TabPane";
import Nav from "reactstrap/lib/Nav";
import NavItem from "reactstrap/lib/NavItem";
import NavLink from "reactstrap/lib/NavLink";

import { gatherClasses, isFunction, requiredIf } from "../../lib/utils";

import "./tab.scss";

const DefaultTab = props => {
  const {
    dataTestId,
    tabbar,
    items,
    onTabClick,
    tabContentTestId,
    activeTabId,
    leftAligned,
    borderBottom,
    noBorderBottomTab,
    navItemClass,
    navLinkClass,
    bodyClass
  } = props;

  const horizontal = !leftAligned ? "center" : null;

  return (
    <div data-testid={dataTestId} className={gatherClasses(props)}>
      <Nav
        tabs
        className={gatherClasses(
          null,
          (tabbar && !borderBottom) || noBorderBottomTab
            ? "oui-no-border"
            : null
        )}
        horizontal={horizontal}
      >
        {items.map((tab, index) => {
          return (
            <NavItem key={index} className={navItemClass}>
              {isFunction(tab.renderComponent) ? (
                tab.renderComponent(tab, index, "oui-active", "oui-nav-link")
              ) : (
                <NavLink
                  href="#"
                  className={gatherClasses(
                    null,
                    activeTabId === tab.id ? "oui-active" : null,
                    tab.isInvalid ? "oui-is-invalid" : null,
                    navLinkClass
                  )}
                  onClick={() => {
                    if (isFunction(onTabClick)) {
                      onTabClick(tab);
                    }
                  }}
                >
                  {tab.title}
                </NavLink>
              )}
              <div className="oui-highlighter" />
            </NavItem>
          );
        })}
      </Nav>

      {tabbar ? null : (
        <TabContent
          data-testid={tabContentTestId || "orion-tab-content"}
          activeTab={activeTabId}
          className={bodyClass}
        >
          {items.map((tab, index) => {
            return (
              <TabPane tabId={tab.id} key={index}>
                {isFunction(tab.component)
                  ? tab.component(tab.id, tab.title)
                  : null}
              </TabPane>
            );
          })}
        </TabContent>
      )}
    </div>
  );
};

DefaultTab.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: requiredIf(
        PropTypes.string,
        props => !isFunction(props.renderComponent)
      ),
      title: requiredIf(
        PropTypes.string,
        props => !isFunction(props.renderComponent)
      ),
      isInvalid: PropTypes.bool,
      component: PropTypes.func,
      renderComponent: PropTypes.func
    })
  ).isRequired,
  activeTabId: PropTypes.string,
  onTabClick: PropTypes.func,
  tabbar: PropTypes.bool,
  dataTestId: PropTypes.string,
  tabContentTestId: PropTypes.string,
  leftAligned: PropTypes.bool,
  borderBottom: PropTypes.bool,
  navItemClass: PropTypes.string,
  navLinkClass: PropTypes.string,
  bodyClass: PropTypes.string,
  noBorderBottomTab: PropTypes.bool
};

DefaultTab.defaultProps = {
  tabbar: false,
  // eslint-disable-next-line react/default-props-match-prop-types
  items: [],
  dataTestId: "orion-tabs",
  leftAligned: false,
  noBorderBottomTab: false
};

DefaultTab.displayName = "OrionCoreTab";

export default DefaultTab;
